import { Injector } from '@angular/core';
import { DocumentsService } from '@data-access/documents/services';
import { DocumentAttribute } from '@data-access/documents/types';
import { EntityType } from '@data-access/submissions';
import { tapResponse } from '@ngrx/operators';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { IResults } from '@shared/iris.interface';
import { pipe, switchMap } from 'rxjs';

const attributeEntity = () =>
  entityConfig({
    collection: '_attribute',
    entity: type<DocumentAttribute>(),
    selectId: (entity: DocumentAttribute) => entity.id,
  });

export const withAttributesEntities = (_injector: Injector) => {
  return signalStoreFeature(
    withEntities(attributeEntity()),
    withMethods((store) => {
      const _fetchAttributes = rxMethod<{
        entityType?: EntityType;
      }>(
        pipe(
          switchMap((params) => {
            const { entityType } = params;
            if (!entityType) {
              throw new Error('entityType is required');
            }
            const docService = _injector.get(DocumentsService);
            return docService.getAttributeTypes('study').pipe(
              tapResponse({
                error: (error: Error) =>
                  console.error('Error loading attributes:', error),
                next: (response: IResults<DocumentAttribute>) => {
                  patchState(
                    store,
                    setAllEntities(response.data, attributeEntity()),
                  );
                },
              }),
            );
          }),
        ),
      );
      return {
        setAttributes: (params: { entityType?: EntityType }) =>
          _fetchAttributes(params),
      };
    }),
  );
};
